module.exports = __webpack_public_path__ + "static/face-min.resized-7a57cedee066e75644381342b34686f2.png";